// scanLogin.styled.tsx
import { Input } from 'antd'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--background-color);
`

export const Logo = styled.img`
  position: absolute;
  top: 24px;
  left: 32px;
  width: 40px;
  height: 40px;
  z-index: 10;
`

export const LoginBox = styled.div`
  width: 384px;
`

export const LoginDetails = styled.div`
  display: flex;
  flex-direction: column;
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const InputWrapper = styled.div`
  width: 100%;
`

export const Label = styled.label`
  color: var(--color-text-primary);
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 10px;
  display: inline-block;
`

export const ErrorWrapper = styled.div`
  color: #e33939;
  font-size: 12px;
  margin-top: 5px;
  margin-left: 2px;
`

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 19px;
`

export const StyledInput = styled(Input)`
  &::placeholder {
    color: #007f7c !important;
  }

  /* Ensures cross-browser support */
  &::-webkit-input-placeholder {
    color: #007f7c !important;
  }
  &:-ms-input-placeholder {
    color: #007f7c !important;
  }
`
